import { useCallback } from 'react';

import { TServerSendRequest } from '../../types';
import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useGetLossLimits = () => {
    const send = useGenericSend();

    return useCallback(async (): Promise<Types.IGetLossLimitsResponseData> => {
        const { data } = await send<TServerSendRequest, Types.IGetLossLimitsResponseData>({
            ID: 35643,
            responses: [35644, 35645],
            description: 'Get Player Loss Limits',
            errorLevel: 1
        });

        return data;
    }, [
        send
    ]);
};
